import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import EntitiesLoader from '../entities/EntitiesLoader/EntitiesLoader';
import { EntityServiceName } from '@api/enums/enums';
//TODO change form
import EvEntityRowForm from '../ev-editor/EvEntityRowForm';
import { ScenarioEventsEntityName } from '@api/types/types';
import CopyScenarioEventActionFabric from '@features/scenario-presets/scenario-events-copy-action/ui/CopyScenarioEventAction';

const getUrlFunc = ({ id }: any) => `./${id}/edit`;

const EmissionsEventsList = () => {
    const entityName = ScenarioEventsEntityName.EmissionEvent;
    const serviceName = EntityServiceName.SCENARIO;
    const { t } = useTranslation();

    const actions = useMemo(
        () => [
            {
                label: t('scenario-case-events.copy-scenario-event-action.action-title'),
                dialogTitle: t('scenario-case-events.copy-scenario-event-action.action-title'),
                dialogContentFabric: CopyScenarioEventActionFabric({ entityName }),
            },
        ],
        [CopyScenarioEventActionFabric]
    );

    return (
        <EntitiesLoader
            entityName={ScenarioEventsEntityName.EmissionEvent}
            layerEntityName={ScenarioEventsEntityName.EmissionEvent}
            serviceName={serviceName}
            form={EvEntityRowForm}
            // linkable={true}
            getUrlFunc={getUrlFunc}
            menuActions={actions}
        />
    );
};

export default EmissionsEventsList;
